import React from 'react';
import DotLoader from 'react-spinners/DotLoader';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import { Colors } from '../../utils/theme';
import { Modal } from '@mui/material';

const useStyles = makeStyles(() => {
  return {
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    '&:focus': {
      outline: 'none'
    }
  };
});

type IProps = {
  loading: boolean;
  modalClasses?: string;
};

const Loader: React.FunctionComponent<IProps> = ({ loading, modalClasses }: IProps) => {
  const classes = useStyles();
  return (
    <Modal className={clsx(classes.modal, modalClasses, 'modalContainer')} open={loading}>
      <div id="loadingContainer">
        <DotLoader size={120} color={Colors.main} loading={true} />
      </div>
    </Modal>
  );
};

export default Loader;
